import React from "react";
import { Skeleton } from "@mui/material";

export const PerformanceMetricsSkeleton: React.FC = () => {
  return (
    <div className="flex w-full max-w-[1024px] flex-col items-start gap-4 px-4 sm:px-0">
      <Skeleton variant="text" width={250} height={28} />
      <div className="flex w-full flex-col items-center rounded-lg bg-default-background shadow-sm">
        <div className="flex w-full flex-col items-start gap-4 sm:gap-6 rounded-lg bg-default-background px-4 sm:px-6 py-4 sm:py-6 shadow-sm">
          <div className="flex w-full flex-col items-start gap-6 sm:gap-8">
            {/* Metric Section Skeleton */}
            <div className="flex flex-col items-start gap-2 w-full">
              <Skeleton variant="text" width={150} height={20} />
              
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8 w-full">
                {/* Metric Card Skeleton */}
                <div className="flex w-full sm:w-44 flex-none flex-col items-start gap-2 rounded-lg border border-solid border-neutral-border bg-default-background px-3 sm:px-4 py-3 sm:py-4 shadow-sm">
                  <div className="flex w-full flex-col items-center gap-2">
                    <div className="flex flex-col items-center">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="text" width={60} height={14} />
                      <Skeleton variant="text" width={70} height={12} />
                    </div>
                    <Skeleton variant="text" width={60} height={32} />
                  </div>
                </div>
                
                {/* Metric Bars Skeleton */}
                <div className="flex flex-col items-start gap-2 w-full sm:w-auto">
                  <div className="flex w-full sm:w-112 flex-col items-start gap-2">
                    <div className="flex w-full sm:w-112 flex-col items-start gap-1">
                      {/* Best Bar */}
                      <div className="flex w-full items-center gap-1">
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="rounded" width="100%" height={8} />
                      </div>
                      {/* You Bar */}
                      <div className="flex w-full items-center gap-1">
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="rounded" width="100%" height={8} />
                      </div>
                      {/* Avg Bar */}
                      <div className="flex w-full items-center gap-1">
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="text" width={40} height={16} />
                        <Skeleton variant="rounded" width="100%" height={8} />
                      </div>
                    </div>
                  </div>
                  {/* Tip Skeleton */}
                  <div className="flex items-center gap-2">
                    <Skeleton variant="circular" width={16} height={16} />
                    <Skeleton variant="text" width={200} height={14} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 